import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { SSPContractsComponent } from '../../../../../pages/datasets/sspcontracts/sspContracts.component';

export const sspContracts: Route = {
  path: 'ssp-contracts',
  title: 'nav.datasets.ssp-contracts',
  data: {
    breadcrumb: 'nav.datasets.ssp-contracts',
    icon: SbIcons.contract,
    id: RoutingID.sspContracts,
  },
  children: [
    {
      path: '',
      component: SSPContractsComponent,
      data: {
        breadcrumb: '',
      },
    },
    // ssps // maybe comment in at a later occasion
  ],
};
